<script setup>
import {useStore} from "vuex";
import {ref, computed, onMounted} from "vue";
import axios from "axios";
import VCard from "@/components/Admin/UI/VCard";
//----------------------------------------------------------------------
const store = useStore()
const isLoading = ref(false)
const history = ref([])
//----------------------------------------------------------------------
onMounted( ()=>{
  init()
})

const init = async () => {
  isLoading.value = true
  store.commit('menuModule/initMenu')

  const url = process.env.VUE_APP_API + "history.php"
  await axios
      .get(`${url}?token=${token.value}&section=${user.value.type}&id=${user.value.id}`)
      .then(response => (history.value = response.data))
      .catch(error => alert(error));

  //console.log(history.value)

  if (history.value.length === 0) {
    setTimeout(() => isLoading.value = false, 3000);
  } else {
    isLoading.value = false
  }
}

//----------------------------------------------------------------------
const token = computed( () => {return store.getters['authModule/token']})
const user = computed( () => {return store.getters['authModule/user']})
</script>

<template>
  <main class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row">
          <div class="col"><h3>История действий</h3></div>
        </div>
      </div>
    </section>
    <section class="content">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12" v-if="user">
            <!-- таблица для desktop -->
            <div class="desktop-only">
              <v-card addClass="card-info card-outline">
                <table
                    v-if="history.length"
                    class="table"
                >
                  <thead>
                  <tr>
                    <th style="width: 180px" class="border-0">Дата</th>
                    <th class="border-0">Обращение</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="item in history" :key="item.Key">
                    <td>{{ item.ActDateTime }}</td>
                    <td>
                      <p>{{ item.Act }}</p>
                      &#10149;
                      <div class="action-detail" v-html="item.Detail"></div>
                    </td>
                  </tr>
                  </tbody>
                </table>
                <div v-else class="d-flex justify-content-center">
                  <div
                      v-if="isLoading"
                      class="spinner-border text-primary m-4" role="status"
                  ></div>
                  <div v-else class="p-4">Нет обращений</div>
                </div>
              </v-card>
            </div>
            <!-- карточки для mobile -->
            <div class="mobile-only">
              <div
                  v-if="history.length"
              >
                <v-card
                    v-for="item in history" :key="item.Key"
                    addClass="card-info card-outline"
                >
                  <p><strong>{{ item.ActDateTime }}</strong></p>
                    <p>{{ item.Act }}</p>
                    &#10149;
                    <div class="action-detail" v-html="item.Detail"></div>
                </v-card>
              </div>
              <div v-else class="d-flex justify-content-center">
                <div
                    v-if="isLoading"
                    class="spinner-border text-primary m-4" role="status"
                ></div>
                <div v-else class="p-4">Нет обращений</div>
              </div>
            </div>
            <!-- ---------------------------------------------------- -->
          </div>
        </div>
      </div>
    </section>
  </main>
</template>
<style scoped>
.action-detail{
  background-color: #f4f6f9;
  padding: 20px;
  margin: -20px 0 0 25px;
  border-radius: 5px;
  border: 1px solid #e3ecf9;
}
.pointer {
  position: absolute;
  border: 10px solid transparent;
  border-bottom: 10px solid #80b5d3;
  margin: -20px 0 0 40px;
}
.desktop-only{
  display: block;
}
.mobile-only{
  display: none;
}
@media only screen and (max-width : 760px) {
  .desktop-only{
    display: none;
  }
  .mobile-only{
    display: block;
  }
  .action-detail{
    padding: 10px;
  }
}
</style>